import {Element, PropsWithChildren, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {useService} from '@yosmanyga/di';
import {AuthenticationFrontendFrontController} from '@yosmanyga/authentication-frontend'
import {AppLanguageController} from '../controller'

const LanguageAndCredentialWrapper = observer(({
        OnNotAuthenticatedComponent,
        children
    }: PropsWithChildren<{
        OnNotAuthenticatedComponent: () => Element
    }>) => {
        const frontController = useService(AuthenticationFrontendFrontController, []);
        const appLanguageController = useService(AppLanguageController, []);

        useEffect(() => {
            (async () => {
                // Dev
                // await frontController.delete();

                await frontController.load();
                await appLanguageController.load();
            })();
        }, []);

        if (
            !frontController.loaded
            || !appLanguageController.loaded
        ) {
            return null;
        }

        if (!frontController.credential || !appLanguageController.language) {
            return <OnNotAuthenticatedComponent/>
        }

        return <>
            {children}
        </>
    }
);

export {LanguageAndCredentialWrapper};
